/**
 * Remove a máscara e espaços de um CNPJ, convertendo para maiúsculas.
 *
 * Caracteres removidos: `.` `/` `-` e espaço.
 * Os demais caracteres são mantidos e convertidos para maiúsculas.
 * A validação estrutural fica a cargo de `validarCnpj`.
 *
 * @param valor - CNPJ com ou sem máscara, em qualquer capitalização.
 *                Aceita `null` e `undefined`, retornando `''` nesses casos.
 * @returns CNPJ normalizado (sem separadores, em maiúsculas),
 *          ou string vazia se a entrada for nula, indefinida ou somente separadores.
 */
export function normalizarCnpj(valor: string | null | undefined): string {
  if (valor == null) return '';
  let resultado = '';
  for (let i = 0; i < valor.length; i++) {
    const c = valor[i];
    if (c !== '.' && c !== '/' && c !== '-' && c !== ' ') {
      resultado += c.toUpperCase();
    }
  }
  return resultado;
}

/**
 * Remove apenas os separadores de máscara de um CNPJ, preservando a capitalização original.
 *
 * Diferente de `normalizarCnpj`, esta função não converte para maiúsculas.
 * Útil quando a preservação do case original é necessária antes de outro processamento.
 *
 * @param valor - CNPJ com ou sem máscara.
 * @returns CNPJ sem separadores, com capitalização preservada.
 */
export function removerMascaraCnpj(valor: string): string {
  let resultado = '';
  for (let i = 0; i < valor.length; i++) {
    const c = valor[i];
    if (c !== '.' && c !== '/' && c !== '-' && c !== ' ') {
      resultado += c;
    }
  }
  return resultado;
}
